// Elevation as defined in the design system.
// https://www.figma.com/file/DNbzluQLbFv7DUK5DuX7n1/%F0%9F%A7%A9-Colours?node-id=210%3A121

export const elevation = [
  'box-shadow: none',
  'box-shadow: 0px 0px 2px rgba(29, 29, 37, 0.07), 0px 2px 2px rgba(29, 29, 37, 0.06), 0px 1px 3px rgba(29, 29, 37, 0.1)',
  'box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07), 0px 1px 10px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.1)',
  'box-shadow: 0px 12px 17px rgba(0, 0, 0, 0.07), 0px 5px 22px rgba(0, 0, 0, 0.06), 0px 7px 8px rgba(0, 0, 0, 0.1)',
];
